import React, { createContext, ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import AuthService from './AuthService';
import { projetosRoute } from 'library/Routes';
import userManager from './oidc.config';
interface AuthContextType {
  signinRedirect: () => void;
  signinRedirectCallback: () => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType>({
  signinRedirect: () => "",
  signinRedirectCallback: () => "",
  logout: () => "",
});

export const AuthConsumer = AuthContext.Consumer;

interface AuthProviderProps {
  children: ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { signinRedirect, signinRedirectCallback, logout } = AuthService();
  const history = useHistory();

  const handleSigninRedirect = () => {
    signinRedirect();
    localStorage.clear();
    sessionStorage.clear()
    userManager.removeUser();
  };

  const handleSigninRedirectCallback = async () => {
    await signinRedirectCallback();
    history.push(projetosRoute.path);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <AuthContext.Provider
      value={{
        signinRedirect: handleSigninRedirect,
        signinRedirectCallback: handleSigninRedirectCallback,
        logout: handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
